import PatentSearch from "../assets/img/website_03.png"
import PatentDraft from "../assets/img/website_02.png"
import DesignPatent from "../assets/img/website_01.png"
import CopyRightServices from "../assets/img/website_04.png"
import TrademarkServices from "../assets/img/website_05.png"
import GeographicalIndication from "../assets/img/GI.png"
const subServiceContent = {
	patent: {
	  service_1: {
		title: "Patent Search",
		description:
		  "At Lifeintelect, we provide comprehensive patent search services to ensure your invention is novel and patentable.",
		  processTitle: "Our process includes:",
		  process: [
		  {
			title: "Understanding Your Invention",
			description:
			  "We begin by understanding the details of your invention and the specific areas where you seek protection.",
		  },
		  {
			title: "Extensive Search",
			description:
			  "Our experts conduct an extensive search using global patent databases, including USPTO, EPO, and WIPO, as well as other relevant literature and non-patent sources.",
		  },
		  {
			title: "Analysis of Search Results",
			description:
			  "We analyse the search results to identify any existing patents or publications that may be similar to your invention. This helps us determine the novelty and potential patentability of your invention, highlighting any possible infringements or obstacles.",
		  },
		  {
			title: "Detailed Search Report",
			description:
			  "Next, we compile a detailed search report summarizing the findings and providing insights into the patent landscape. This report includes an analysis of relevant prior art and recommendations on how to proceed with your patent application. Lifeintelect's patent search service is designed to give you a clear understanding of where your invention stands in the global intellectual property landscape. With our thorough approach and expert analysis, you can move forward with confidence",
		  },
		],
		typesSection: {
			image: PatentSearch,
		  types: [
			{
			  title: "Patentability Search",
			  description:
				"Our patentability search determines whether an invention is novel and patentable before applying for patent protection. Our experts conduct a thorough search of global patent databases and other relevant sources to find any prior art similar to the invention. This helps us evaluate the novelty and potential patentability of the invention. Conducting a patentability search helps in drafting a strong patent specification that highlights the true novelty and usefulness of the invention. We provide full documentation of all patentability searches in the form of a patent search report, which includes detailed analysis and recommendations.",
			},
			{
			  title: "Freedom to Operate (FTO) Search",
			  description:
				"A freedom to operate (FTO) search and analysis determine the risk of patent infringement in a particular jurisdiction before launching a product or using a process. Our experts perform a comprehensive search of patent literature for issued or pending patents and obtain a legal opinion on whether a product, process, or service may infringe existing patents owned by others. An FTO search and analysis help businesses mitigate the risk of patent infringement and identify potential opportunities for collaboration or licensing. We provide a detailed FTO search report that includes an analysis of potential infringement risks and recommendations for proceeding.",
			},
			{
			  title: "Validity or Invalidity Search",
			  description:
				"A validity or invalidity search identifies prior art that could invalidate or challenge the validity of a granted patent. Our experts conduct a comprehensive search of all publicly available valid documents, including patents, scientific literature, and other relevant sources. We perform detailed research and claim mapping to assess the validity or invalidity of a granted patent. A validity or invalidity search helps patent holders defend their patents against challenges or oppositions and assists in challenging the validity of competitors' patents, providing a strategic advantage in the market. We provide a detailed search report that includes an analysis of relevant prior art and recommendations for proceeding with validity or invalidity claims.",
			},
			{
			  title: "State of the Art or Technology Landscape Analysis",
			  description:
				"A state-of-the-art or technology landscape analysis helps clients understand the evolution of a particular technology and the overall technology trends in multiple domains. Our experts conduct a comprehensive search and analysis of patent literature, scientific publications, and other relevant sources to identify technological trends, major players, and competitors' strengths. We analyse patent activities related to the technology of interest. A state-of-the-art or technology landscape analysis provides valuable insights into the technological advancements and competitive landscape, helping clients formulate R&D strategies, plan product launches, and understand competitors' strategies. We provide a detailed analysis report that includes insights into technology trends, major players, and recommendations for strategic decision-making.",
			},
		  ],
		  
		},
	  },
	  service_2: {
		title: "Patent Drafting",
		description:
		  "Patent drafting is one of the most critical documents in the entire patent registration process and is also considered one of the most complex techno-legal documents. This document contains the features of the invention for which protection is being sought in the form of claims. Our strong team, working in organized and effective internal processes, understands your invention to deliver excellent provisional and complete specification patent drafts. The patent specification we draft and file for you meets the standards and requirements of the US, EP, WO, and Indian jurisdictions.",
		image: PatentDraft,
		typesSection: {
		types: [
		  {
			title: "Provisional Patent Specification Drafting",
			description:
			  "When an idea or invention is not fully developed and has considerable details that need to be worked on, a provisional patent specification draft is filed, allowing a 12-month period to formulate the complete patent specification draft and file it.",
		  },
		  {
			title: "Complete Patent Specification Drafting",
			description:
			  "A complete patent specification draft involves a comprehensive approach to include all aspects of the idea or invention, including related future developments.",
		  },
		  {
			title: "PCT Application",
			description:
			  "A PCT application can be filed under the Patent Corporation Treaty for protection in 148 member countries across the world under the same treaty. It is the most efficient and cost-effective way to engage in the patenting process in multiple countries simultaneously.",
		  },
		  {
			title: "Patent Illustrations",
			description:
			  "Patent illustrations involve drafting and filing technical drawings for protection. Our experts have substantial knowledge and experience working on all forms of illustrations in accordance with Patent Office specifications.",
		  },
		  {
			title: "Office Actions",
			description:
			  "Our specialized team of patent attorneys, registered patent agents, and technologists has experience in successfully handling patent filing and prosecution in India, timely responding to office actions. We work closely with you to draw up the final and non-final office action responses by meticulously drafting comments, arguments, and amendments that are acceptable under patent law by the examiner. To file the right kind of patent draft, our experts meticulously construct and formulate claims, preventing others from finding ways to copy your idea or parts of it. We customize our services to meet your needs at affordable prices, turning ideas into high-quality enforceable patents that encompass every aspect of the invention.",
		  },
		]
	}
	  },
	  service_3: {
		title: "Patent Filing",
		description:
		  "At Lifeintelect, we handle the entire patent filing process for you, ensuring your invention is protected efficiently and effectively.",
		subsections: [
		  {
			heading: "Our Process",
			items: [
			  {
				title: "Patent Search and Application Drafting",
				description:
				  "We begin by conducting a thorough patent search to confirm your invention's novelty. Following this, we draft a detailed patent application, including the title, abstract, background, description, and claims. Depending on your needs, we decide whether to file a provisional application to secure an early filing date or proceed directly with a non-provisional application to start the formal examination process.",
			  },
			  {
				title: "Application Submission and Office Action Response",
				description:
				  "We manage the submission of your application to the relevant patent office, ensuring all documents are correctly filed. We handle all the required fees and keep you informed throughout the process. If the patent office issues any office actions, we address them promptly, making necessary amendments and providing strong arguments to support your application's approval.",
			  },
			  {
				title: "Patent Issuance and Maintenance",
				description:
				  "Once your patent is approved, we guide you through paying the issuance fee and help you obtain your official patent certificate. We also manage the maintenance of your patent, ensuring all necessary fees are paid on time to keep your patent active.",
			  },
			  {
				title: "International Patent Protection via PCT",
				description:
				  "In addition to national filings, we assist with the Patent Cooperation Treaty (PCT) process, enabling you to seek patent protection internationally. We prepare and file PCT applications, manage the international phase, and ensure timely entry into national phases in desired countries. Our expertise in navigating the complexities of the PCT process ensures broad and strategic protection for your invention across multiple jurisdictions.",
			  },
			],
		  },
		],
	  },
	  service_4: {
		title: "Patent Prosecution",
		description:
		  "At Lifeintelect, we manage every aspect of the patent prosecution process, ensuring your application moves smoothly through the examination phase towards approval.",
		subsections: [
		  {
			heading: "Our Process",
			items: [
			  {
				title: "Tracking & Office Action Handling",
				description:
				  "After filing your patent application, we continuously monitor its progress and respond to any office actions from the patent office. These office actions may include objections or rejections based on prior art or other examination findings. Our team of experts carefully reviews these actions and prepares detailed responses to address any issues that arise.",
			  },
			  {
				title: "Examiner Communication & Amendments",
				description:
				  "We engage in strategic communication with patent examiners, making necessary amendments to the application and providing robust arguments to support the patentability of your invention. This process may involve several rounds of correspondence and adjustments to ensure the application meets all legal and technical requirements.",
			  },
			],
		  },
		],
	  },
	  service_5: {
		title: "Patent Maintenance",
		description:
		  "At Lifeintelect, we take the hassle out of patent maintenance, ensuring your patent remains in force for its full term.",
		subsections: [
		  {
			heading: "Our Process",
			items: [
			  {
				title: "Tracking Deadlines",
				description:
				  "After your patent is granted, it’s essential to pay periodic maintenance fees to keep it valid. These fees are typically due at regular intervals and vary depending on the jurisdiction. At Lifeintelect, we meticulously track these deadlines to ensure no payments are missed.",
			  },
			  {
				title: "Handling Payments",
				description:
				  "Our team handles all aspects of maintenance fee payments, from calculating the correct amounts to processing the payments on your behalf. We also provide reminders and updates so you’re always informed about upcoming deadlines and any changes in fee schedules.",
			  },
			  {
				title: "Resolving Issues",
				description:
				  "If there are any issues or complications with maintaining your patent, we address them promptly, ensuring your patent rights remain protected. Our service includes managing communications with the patent office and resolving any discrepancies that may arise.",
			  },
			],
		  },
		],
		closing:
		  "With Lifeintelect, you can focus on leveraging your innovation while we take care of the administrative complexities of patent maintenance. Trust us to keep your patents active and enforceable, safeguarding your valuable intellectual property. Ready to ensure your patents stay protected? Let's get started!",
	  },
	  service_6: {
		title: "NBA Approval",
		description:
		  "At LifeIntelect Consultancy, we offer an additional service to assist clients in securing approval from the National Biodiversity Authority (NBA) for intellectual property (IP) involving biological materials. Our Patent team is highly knowledgeable about the National Biodiversity Act and its implications for Patent Law. We thoroughly evaluate your invention to determine if NBA approval is required and provide expert advice on the necessary steps to comply with regulations. Our comprehensive support includes preparing and submitting the required documentation to the NBA, such as research proposals and consent letters. By partnering with LifeIntelect Consultancy, you can ensure that your IP filings involving biological resources are compliant with national standards and protected under the law. This service adds an extra layer of security and compliance, giving you the confidence to innovate and contribute to the sustainable use of India's rich biodiversity.",
		subsections: [
		  {
			heading: "NBA Filing",
			description:
			  "At Lifeintelect we ensure that all necessary steps for NBA (National Biodiversity Authority) compliance are followed meticulously. Here’s the process we follow:",
			steps: [
			  {
				title: "Assessing Biological Resource Use",
				description:
				  "First, we assess the biological resource used in the invention, ensuring that it involves any plant, animal, microbial, or genetic material that requires NBA approval. We confirm if the biological resource is sourced from India or has been accessed through traditional knowledge.",
			  },
			  {
				title: "Documenting the Origin of Biological Resources",
				description:
				  "We collect and document detailed information about the biological resources used in the invention.",
				subPoints: [
				  "The exact source of the biological material (e.g., from nature, research institutions, or indigenous communities).",
				  "The method of collection or acquisition.",
				  "Any agreements related to the collection (e.g., Memorandum of Understanding (MoU) with local communities).",
				],
			  },
			  {
				title: "Filing the NBA Application",
				description:
				  "We prepare and file an application with the NBA.",
				subPoints: [
				  "Detailed descriptions of the invention and how biological resources are used.",
				  "Proof of prior approval from the NBA (if required) for accessing biological resources.",
				  "A declaration of compliance with the Biodiversity Act and relevant regulations.",
				],
			  },
			  {
				title: "Follow-up with the NBA",
				description:
				  "After submission, we monitor the application’s progress and work closely with the NBA to address any queries or additional documentation they may require. We ensure that all formalities are completed promptly and the approval process is smooth.",
			  },
			  {
				title: "Compliance and Reporting",
				description:
				  "Once the patent is granted and the biological resource use is approved, we ensure that all ongoing compliance requirements are met. This could include reporting to the NBA about how the resource is being used or any modifications to the invention.",
			  },
			],
		  },
		],
	  },
	},
	design: {
	  service_1: {
		title: "Industrial Design",
		description:
		  "Industrial design/ Design Patent has great relevance in industrial era. It adds value to your IP portfolio. Basically, Design is the “visual aspect’ of the product, that is the shape, pattern, combination of pattern, colour, configuration or ornamentation which are applied to articles but not the utility of the article.",
		description1:
		  "Design registration process varies from country to country, we assist with registration of design in India & abroad. We provide search, analysis, registration, office actions, maintenance, portfolio management & risk assessment of the Design Patent. ",
		image: DesignPatent,
	  },
	  service_2: {
		title: "Design Drafting",
		description:
		  "At Lifeintelect, we offer expert design drafting services to ensure your visual creations are meticulously documented and protected. Here's how we handle the process:",
		process: [
		  {
			title: "Understanding Your Design",
			description:
			  "We begin by understanding the unique visual aspects of your design that you want to protect.",
		  },
		  {
			title: "Creating Representations",
			description:
			  "Our team of skilled designers and patent drafters then create detailed, accurate representations of your design.",
			subPoints: [
			  "Drawings and Illustrations: Precise drawings and illustrations that clearly depict the ornamental features of your design from various angles.",
			  "Descriptions: Thorough descriptions that explain the visual elements and highlight the unique aspects of your design.",
			],
		  },
		  {
			title: "Meeting Patent Office Requirements",
			description:
			  "We ensure that all drawings and descriptions meet the specific requirements of the patent office in the jurisdiction where you seek protection. Our expertise in design law and drafting standards helps to maximize the chances of your design application being approved.",
		  },
		],
		closing:
		  "Lifeintelect’s design drafting service is tailored to provide robust and clear documentation for your design, safeguarding its unique visual attributes. With our expert guidance and meticulous approach, you can confidently protect your design.",
	  },
	  service_3: {
		title: "Design Filing",
		description:
		  "At Lifeintelect, we handle every aspect of design filing to ensure your creations are protected efficiently.",
		process: [
		  {
			title: "Design Search & Application Drafting",
			description:
			  "We start by confirming the originality of your design through thorough searches. Once verified, our experts draft a detailed application, including precise drawings and comprehensive descriptions that highlight the unique features of your design",
		  },
		  {
			title: "Submission & Office Action Management",
			description:
			  "Once your design is approved, we guide you through the issuance process and help you obtain the official design certificate. Lifeintelect also offers ongoing support for maintaining your design rights, including managing renewals and monitoring for potential infringements.",
		  },
		  {
			title: "Design Certification & Support",
			description:
			  "Once your design is approved, we guide you through the issuance process and help you obtain the official design certificate. Lifeintelect also offers ongoing support for maintaining your design rights, including managing renewals and monitoring for potential infringements.",
		  },
		],
		closing:
		  "With Lifeintelect’s design filing services, you can rest assured that your visual creations are in expert hands.",
	  },
	  service_4: {
		title: "Design Prosecution",
		description:
		  "At Lifeintelect, we expertly manage the design prosecution process, ensuring your design application moves smoothly through examination to approval.",
		subsections: [
		  {
			heading: "Our Process",
			items: [
			  {
				title: "Monitoring Application",
				description:
				  "Once your design application is filed, we monitor its progress closely.",
			  },
			  {
				title: "Responding to Office Actions",
				description:
				  "If the patent office issues any office actions, such as objections or rejections based on prior art or examination findings, our team steps in promptly. We carefully review these actions and prepare detailed responses to address any issues raised by the patent examiners.",
			  },
			  {
				title: "Strategic Communication",
				description:
				  "We engage in strategic communication with the patent office, making necessary amendments to your application and providing strong arguments to support the distinctiveness and originality of your design. This process may involve several rounds of correspondence and adjustments to ensure compliance with all legal and technical requirements.",
			  },
			  {
				title: "Keeping You Informed",
				description:
				  "Throughout the prosecution process, we keep you informed and involved, explaining our strategy and the steps we're taking to secure your design protection.",
			  },
			  {
				title: "Final Steps",
				description:
				  "Once the patent office is satisfied with the responses, we guide you through paying any required issuance fees and help you obtain your official design certificate.",
			  },
			],
		  },
		],
	  },
	  service_5: {
		title: "Design Maintenance",
		description:
		  "At Lifeintelect, we handle the maintenance of your design patents to ensure they remain valid and enforceable.",
		subsections: [
		  {
			heading: "Our Process",
			items: [
			  {
				title: "Tracking Deadlines",
				description:
				  "Once your design patent is granted, it's crucial to pay periodic maintenance fees to keep it in force. These fees vary depending on the jurisdiction and are required at regular intervals. At Lifeintelect, we track these deadlines meticulously to ensure no payments are missed.",
			  },
			  {
				title: "Handling Payments",
				description:
				  "Our team takes care of all aspects of maintenance fee payments, from calculating the correct amounts to processing the payments on your behalf. We also provide reminders and updates, keeping you informed about upcoming deadlines and any changes in fee schedules.",
			  },
			  {
				title: "Resolving Issues",
				description:
				  "If there are any issues or complications with maintaining your design patent, we address them promptly, ensuring your design rights remain protected. This includes managing communications with the patent office and resolving any discrepancies that may arise.",
			  },
			],
		  },
		],
		closing:
		  "Lifeintelect’s comprehensive design maintenance services are designed to give you peace of mind, allowing you to focus on leveraging your design while we take care of the administrative complexities. Trust us to keep your design patents active and enforceable.",
	  },
	  service_6: {
		title: "Design Portfolio Management",
		description:
		  "We offer comprehensive portfolio management services to help you keep track of all your registered designs and their status.",
		subsections: [
		  {
			heading: "Our Process",
			items: [
			  {
				title: "Monitoring and Updates",
				description:
				  "This includes monitoring for potential conflicts, managing renewals, and ensuring that your designs remain protected and in good standing.",
			  },
			  {
				title: "Strategic Advice",
				description:
				  "Our team provides regular updates and strategic advice to optimize your design portfolio, helping you maintain the integrity and value of your visual creations.",
			  },
			],
		  },
		],
	  },
	  service_7: {
		title: "Risk Assessment",
		description:
		  "We conduct risk assessments to identify and mitigate potential threats to your industrial designs.",
		subsections: [
		  {
			heading: "Our Process",
			items: [
			  {
				title: "Risk Identification and Analysis",
				description:
				  "Our experts analyze the design landscape, identify potential conflicts, and provide recommendations to minimize risks. This proactive approach helps you maintain the uniqueness of your designs and avoid legal complications.",
			  },
			  {
				title: "Strategic Protection Planning",
				description:
				  "We work closely with you to develop strategies that protect your designs from potential infringements and ensure their continued success in the market.",
			  },
			],
		  },
		],
	  },
	  service_8: {
		title: "Design Audit",
		description:
		  "Our design audit services help you assess and manage your existing design portfolio.",
		subsections: [
		  {
			heading: "Our Process",
			items: [
			  {
				title: "Comprehensive Audit",
				description:
				  "We conduct thorough audits to identify all your registered designs, evaluate their status, and ensure that all necessary registrations and renewals are up to date.",
			  },
			  {
				title: "Strategic Recommendations",
				description:
				  "Our team provides recommendations for optimizing your design strategy and maximizing the value of your intellectual property. We help you identify any gaps or areas for improvement, ensuring that your designs are fully protected and strategically managed.",
			  },
			],
		  },
		],
		closing:
		  "With Lifeintelect's expert guidance and comprehensive services, you can rest assured that your industrial designs are well-protected at every stage. Ready to safeguard your designs with Lifeintelect? Let's get started!",
	  },
	},
	copyright: {
	  service_1: {
		title: "Copyright",
		description:
		  "Copyright is a bundle of exclusive rights vested in the author/owner/creator to do or authorize others to do certain acts in relation to their works. Copyrights cover much broader ground including artistic, literary, musical, dramatic works, cinematographic films, sound recordings, computer software and data bases. We provide copyright analysis reports to clients on various aspects of copyright law that enable them to make decisions on various strategic and business issues.",
		image: CopyRightServices,
	  },
	  service_2: {
		title: "Copyright Filing and Registration",
		description:
		  "We handle the entire filing and registration process, ensuring your copyright application is submitted correctly and efficiently to the relevant copyright office. Our team prepares all necessary documentation, including detailed descriptions of your work, and ensures that your application meets all legal and procedural requirements. We take care of all required fees and keep you informed throughout the process, providing updates on the status of your application.",
	  },
	  service_3: {
		title: "Copyright Opinions",
		description:
		  "We provide expert opinions on various copyright issues, helping you understand your rights and the scope of protection for your creative works. Whether you need guidance on copyright eligibility, fair use, or potential infringements, our team of legal experts is here to assist you. We offer clear and concise advice tailored to your specific needs and circumstances.",
	  },
	  service_4: {
		title: "Copyright Objections",
		description:
		  "If there are any issues or objections from the copyright office, our team will address them promptly. We prepare detailed responses to any objections or rejections, providing additional documentation if needed, and engaging in necessary communication to resolve any issues. Our goal is to ensure that your copyright application is approved without unnecessary delays.",
	  },
	  service_5: {
		title: "Online Risk Management",
		description:
		  "We help you protect your copyrighted works online by monitoring for potential infringements and unauthorized use. Our team provides guidance on how to enforce your rights and take action if someone violates your copyright. We offer comprehensive online risk management services, including takedown notices, cease-and-desist letters, and legal action if necessary. Our proactive approach ensures that your creative works remain protected in the digital landscape.",
	  },
	  service_6: {
		title: "Content Monitoring",
		description:
		  "We provide ongoing monitoring services to track the use of your copyrighted content across various platforms. Our team uses advanced tools and techniques to identify unauthorized use of your work, ensuring that your rights are upheld. We provide regular reports and updates on our findings and take necessary actions to address any infringements.",
	  },
	  service_7: {
		title: "Digital Rights Management",
		description:
		  "We offer digital rights management (DRM) solutions to protect your digital content from unauthorized access and distribution. Our DRM services include encryption, access control, and digital watermarking to safeguard your intellectual property. We work with you to develop customized DRM strategies that meet your specific needs and ensure that your digital content is secure.",
	  },
	  service_8: {
		title: "Copyright Audit",
		description:
		  "Our copyright audit services help you assess and manage your existing copyright portfolio. We conduct thorough audits to identify all your copyrighted works, evaluate their status, and ensure that all necessary registrations and renewals are up to date. Our team provides recommendations for optimizing your copyright strategy and maximizing the value of your intellectual property.",
	  },
	},
	trademark: {
		service_1: {
		  title: "Trademark",
		  description:
			"At Lifeintelect, we understand the importance of protecting your creative works and intellectual property. With our expert guidance and comprehensive services, you can rest assured that your creations are well-protected at every stage. Ready to safeguard your creations with Lifeintelect? Let's get started!",
		  description1:
			"Trademark is a mark capable of being represented graphically and which is capable of distinguishing the goods or services of one person from those of others. The function of trademark is identification of source, quality and act as an advertising symbol.",
		  description2:
			"We provide trademark search and Trademark analysis services. Our search reports are accompanied by a trademark opinion suggesting the possibility of registering the client’s trademark.",
		  description3:
			"We also provide risk analysis reports that enable clients to make decisions with respect to trademark use, opposition and infringement. Our reports enable clients to make decisions on various aspects of their trade mark portfolio",
		  description4:
			"We offer trademark filing and registration services in India and internationally.",
		  image: TrademarkServices,
		},
		service_2: {
		  title: "Trademark Search and Analysis",
		  description:
			"We begin by conducting a thorough search to identify any existing trademarks that may be similar to your proposed mark. This search includes checking various trademark databases and other relevant sources to confirm the uniqueness of your brand. Our experts analyse the results and provide a detailed report on the availability and registrability of your trademark, helping you make informed decisions.",
		},
		service_3: {
		  title: "Trademark Filing and Registration",
		  description:
			"We handle the entire filing and registration process, ensuring your trademark application is submitted correctly and efficiently to the relevant trademark office. Our team prepares all necessary documentation, including detailed descriptions of your mark and its usage, and ensures that your application meets all legal and procedural requirements. We take care of all required fees and keep you informed throughout the process, providing updates on the status of your application.",
		},
		service_4: {
		  title: "Trademark Prosecution and Renewal",
		  description:
			"If there are any issues or queries from the trademark office, our team will address them promptly. We prepare detailed responses to any objections or rejections, providing additional documentation if needed, and engaging in necessary communication to resolve any issues. Our goal is to ensure that your trademark application is approved without unnecessary delays. Additionally, we handle the renewal process to keep your trademark in force, managing all required documentation and fees.",
		},
		service_5: {
		  title: "Opposition and Rectification",
		  description:
			"If your trademark faces opposition or if you need to challenge the registration of a conflicting mark, our team provides robust support. We prepare and file opposition or rectification petitions, represent you in hearings, and provide strategic advice to strengthen your case. Our experts work diligently to protect your brand from potential conflicts and ensure that your trademark rights are upheld.",
		},
		service_6: {
		  title: "Portfolio Management",
		  description:
			"We offer comprehensive portfolio management services to help you keep track of all your trademarks and their status. This includes monitoring for potential conflicts, managing renewals, and ensuring that your trademarks remain protected and in good standing. Our team provides regular updates and strategic advice to optimize your trademark portfolio.",
		},
		service_7: {
		  title: "Risk Assessment",
		  description:
			"We conduct risk assessments to identify and mitigate potential threats to your trademark. Our experts analyze the trademark landscape, identify potential conflicts, and provide recommendations to minimize risks. This proactive approach helps you maintain the integrity of your brand and avoid legal complications.",
		},
		service_8: {
		  title: "Trademark Watch",
		  description:
			"We offer trademark watch services to monitor the use of your trademark and identify any unauthorized usage or potential infringements. Our team uses advanced tools and techniques to track trademark applications and registrations that may conflict with your mark. We provide regular reports and take necessary actions to protect your trademark rights.",
		  closing:
			"At Lifeintelect, we understand the importance of protecting your brand identity and intellectual property. With our expert guidance and comprehensive services, you can rest assured that your trademarks are well-protected at every stage. Ready to safeguard your brand with Lifeintelect? Let's get started!",
		},
	  },
	  
	geographicalIndications: {
		service_1: {
		  title: "Geographical Indications",
		  description:
			"At LifeIntelect, we recognize the importance of protecting Geographical Indications (GI) as a valuable form of intellectual property. Our expert guidance and comprehensive services ensure that your GI-protected products are well-protected at every stage. Ready to safeguard your GI with LifeIntelect? Let's get started!",
		  description1:
			"A Geographical Indication (GI) is a sign used on products that have a specific geographical origin and possess qualities, reputation, or characteristics inherent to that location. The function of GI is to certify the origin, quality, and reputation of products, acting as a mark of authenticity and distinction in the market.",
		  description2:
			"We provide GI search and GI analysis services. Our search reports are accompanied by an expert opinion suggesting the possibility of registering the client's GI.",
		  description3:
			"We also provide risk analysis reports that enable clients to make informed decisions regarding GI use, opposition, and infringement. Our reports help clients manage various aspects of their GI portfolio effectively.",
		  description4:
			"We offer GI filing and registration services in India and internationally, ensuring that your products receive the protection they deserve in domestic and global markets.",
			image:GeographicalIndication,
		  closing:
			"Ready to safeguard your GI with LifeIntelect? Let's get started!",
		},
		service_2: {
		  title: "GI Search and Analysis",
		  description:
			"We conduct thorough searches to analyse and identify potential Geographical Indications (GI) for your products. Our comprehensive analysis ensures that your product meets the criteria for GI registration and helps you understand the market potential and legal implications.",
		//   closing:
		// 	"Our GI search and analysis services provide the foundation for successful registration.",
		},
		service_3: {
		  title: "GI Filing and Registration",
		  description:
			"Our team assists you in the preparation and filing of GI applications. We ensure that all necessary documents and evidence are meticulously prepared to meet the requirements of the relevant authorities, facilitating a smooth and efficient registration process.",
		//   closing:
		// 	"With LifeIntelect’s filing and registration services, your GI is protected efficiently.",
		},
		service_4: {
		  title: "GI Prosecution and Renewal",
		  description:
			"We manage the prosecution of GI applications, responding to any objections or queries from the authorities. Additionally, we handle the renewal of GIs to maintain their protection and ensure that your rights remain intact.",
		//   closing:
		// 	"Our prosecution and renewal services keep your GI protection active and secure.",
		},
		service_5: {
		  title: "Opposition and Rectification",
		  description:
			"We represent clients in opposition proceedings to challenge the registration of conflicting GIs. Our team also handles rectification cases to correct any errors or inaccuracies in registered GIs, safeguarding your interests.",
		//   closing:
		// 	"LifeIntelect’s opposition and rectification services protect your GI from conflicts.",
		},
		service_6: {
		  title: "Portfolio Management",
		  description:
			"Our portfolio management services include the strategic planning and maintenance of your GI portfolio. We help you track and manage your GIs, ensuring they are effectively leveraged to enhance your brand and market presence.",
		//   closing:
		// 	"Our portfolio management services optimize your GI assets for maximum value.",
		},
		service_7: {
		  title: "Risk Assessment",
		  description:
			"We conduct risk assessments to identify potential threats to your GI protection. Our proactive approach helps you mitigate risks and take necessary actions to safeguard your valuable GIs from infringement and misuse.",
		//   closing:
		// 	"With LifeIntelect’s risk assessment services, your GIs are protected from potential threats. Ready to enhance your GI protection? Let's get started!",
		},
	  },
  };
  
  export default subServiceContent;